type ErrorRefItem = {
  name: string;
  ref: React.RefObject<HTMLElement> | null;
};

const focusFirstError = (
  errors: Record<string, any>,
  orderedRefs: ErrorRefItem[]
) => {
  for (const { name, ref } of orderedRefs) {
    // console.log("error name", name);
    if (errors[name]) {
      if (ref?.current) {
        ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      break;
    }
  }
};

export default focusFirstError;